import * as actionTypes from './actionTypes';
import { EventTrackingActionCreator } from '../../declarations';

export function maybeFetchSessionInfo() {
  return {
    payload: {},
    type: actionTypes.MAYBE_FETCH_SESSION_INFO,
  };
}

export function fetchSessionInfo() {
  return {
    payload: {},
    type: actionTypes.FETCH_SESSION_INFO,
  };
}

export function beginLoadingSessionInfo() {
  return {
    payload: {},
    type: actionTypes.BEGIN_LOADING_SESSION_INFO,
  };
}

export function receiveSessionInfo(info) {
  return {
    payload: { info },
    type: actionTypes.RECEIVE_SESSION_INFO,
  };
}

export function errorSessionInfo(error) {
  return {
    payload: { error },
    type: actionTypes.ERROR_SESSION_INFO,
  };
}

export function beginLogIn() {
  return {
    payload: {},
    type: actionTypes.BEGIN_LOG_IN,
  };
}

export function errorLogIn(error: string, statusCode?: number) {
  return {
    payload: { error, statusCode },
    type: actionTypes.ERROR_LOG_IN,
  };
}

export function logIn(
  email?: string,
  password?: string,
  googleIDToken?: string,
  facebookIDToken?: string,
) {
  return {
    payload: { email, password, googleIDToken, facebookIDToken },
    type: actionTypes.LOG_IN,
  };
}

export function successLogIn(serverLoginRedirect?: string) {
  return {
    payload: { serverLoginRedirect },
    type: actionTypes.SUCCESS_LOG_IN,
  };
}

export function beginRequestHumanStatus() {
  return {
    payload: {},
    type: actionTypes.BEGIN_REQUEST_HUMAN_STATUS,
  };
}

export function errorRequestHumanStatus(error: string, statusCode?: number) {
  return {
    payload: { error, statusCode },
    type: actionTypes.ERROR_REQUEST_HUMAN_STATUS,
  };
}

export function requestHumanStatus(email: string) {
  return {
    payload: { email },
    type: actionTypes.REQUEST_HUMAN_STATUS,
  };
}

export function successRequestHumanStatus(
  email: string,
  hasGeneratedPassword?: boolean,
  isNewHuman = false,
) {
  return {
    payload: { email, hasGeneratedPassword, isNewHuman },
    type: actionTypes.SUCCESS_REQUEST_HUMAN_STATUS,
  };
}

export function beginRequestPasswordReset() {
  return {
    payload: {},
    type: actionTypes.BEGIN_REQUEST_RESET_PASSWORD,
  };
}

export function errorRequestPasswordReset(error: string, statusCode?: number) {
  return {
    payload: { error, statusCode },
    type: actionTypes.ERROR_REQUEST_RESET_PASSWORD,
  };
}

export function requestPasswordReset(email: string) {
  return {
    payload: { email },
    type: actionTypes.REQUEST_RESET_PASSWORD,
  };
}

export function successRequestPasswordReset(
  email: string,
  hasGeneratedPassword?: boolean,
  isNewHuman = false,
) {
  return {
    payload: { email, hasGeneratedPassword, isNewHuman },
    type: actionTypes.SUCCESS_REQUEST_RESET_PASSWORD,
  };
}

export function beginRegister() {
  return {
    payload: {},
    type: actionTypes.BEGIN_REGISTER,
  };
}

export function errorRegister(error: string) {
  return {
    payload: { error },
    type: actionTypes.ERROR_REGISTER,
  };
}

export function register(
  email?: string,
  name?: string,
  password?: string,
  phone?: string,
  googleIDToken?: string,
  facebookIDToken?: string,
  passwordlessToken?: string,
  hasGeneratedPassword?: boolean,
) {
  return {
    payload: {
      email,
      name,
      password,
      phone,
      googleIDToken,
      facebookIDToken,
      passwordlessToken,
      hasGeneratedPassword,
    },
    type: actionTypes.REGISTER,
  };
}

export function successRegister() {
  return {
    payload: {},
    type: actionTypes.SUCCESS_REGISTER,
  };
}

export function maybeLogOut() {
  return {
    payload: {},
    type: actionTypes.MAYBE_LOG_OUT,
  };
}

export function loggedOut() {
  return {
    payload: {},
    type: actionTypes.LOGGED_OUT,
  };
}
export const trackEvent: EventTrackingActionCreator<typeof actionTypes.TRACK_EVENT> = (
  category,
  action,
  label,
  extra,
) => {
  return {
    payload: { category, action, label, extra },
    type: actionTypes.TRACK_EVENT,
  };
};
